module.exports = __webpack_public_path__ + "static/media/Doublade_gaussian2.1d9c141b.png";